// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1zwy4","errorLogs":"EditorFooter_errorLogs__2nrdg"};